// テキスト → OpenAI TTS（Worker経由）→ Audio 再生

const API_BASE = import.meta.env.VITE_API_BASE || '';

export class Speaker {
  constructor() {
    this.audio = null;
    this.audioUrl = null;
    this.onTimeUpdate = null;
    this.onEnded = null;
    this.playbackRate = 1.0;
  }

  setPlaybackRate(rate) {
    this.playbackRate = rate;
    if (this.audio) this.audio.playbackRate = rate;
  }

  getPlaybackRate() {
    return this.playbackRate;
  }

  skip(seconds) {
    if (!this.audio) return;
    const target = Math.min(
      Math.max(0, this.audio.currentTime + seconds),
      Number.isFinite(this.audio.duration) ? this.audio.duration : Infinity
    );
    this.audio.currentTime = target;
  }

  getCurrentTime() {
    return this.audio?.currentTime ?? 0;
  }

  getDuration() {
    return this.audio?.duration ?? 0;
  }

  async load(text, lang = 'ja') {
    this.dispose();

    const res = await fetch(`${API_BASE}/api/tts`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text, lang }),
    });

    if (!res.ok) {
      const msg = await safeErrorMessage(res);
      throw new Error(msg);
    }

    const blob = await res.blob();
    this._mountAudio(blob);
    return blob;
  }

  async loadFromBlob(blob) {
    this.dispose();
    this._mountAudio(blob);
  }

  _mountAudio(blob) {
    this.audioUrl = URL.createObjectURL(blob);
    this.audio = new Audio(this.audioUrl);
    this.audio.preload = 'auto';
    this.audio.playsInline = true;
    this.audio.playbackRate = this.playbackRate;

    this.audio.addEventListener('timeupdate', () => {
      if (this.onTimeUpdate) this.onTimeUpdate(this.audio.currentTime, this.audio.duration);
    });
    this.audio.addEventListener('ended', () => {
      if (this.onEnded) this.onEnded();
    });
  }

  async play() {
    if (!this.audio) return;
    try {
      await this.audio.play();
    } catch (err) {
      throw new Error('音声再生はタップ操作から開始してください');
    }
  }

  pause() {
    if (this.audio) this.audio.pause();
  }

  isPlaying() {
    return this.audio && !this.audio.paused && !this.audio.ended;
  }

  seek(seconds) {
    if (this.audio && Number.isFinite(seconds)) this.audio.currentTime = seconds;
  }

  dispose() {
    if (this.audio) {
      this.audio.pause();
      this.audio.src = '';
      this.audio = null;
    }
    if (this.audioUrl) {
      URL.revokeObjectURL(this.audioUrl);
      this.audioUrl = null;
    }
  }
}

async function safeErrorMessage(res) {
  try {
    const data = await res.json();
    return data?.error || `音声化に失敗しました (${res.status})`;
  } catch {
    return `音声化に失敗しました (${res.status})`;
  }
}
